import { NgModule } from '@angular/core';
import {
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbAccordionModule,
} from '@ng-bootstrap/ng-bootstrap';
import { DfFormlyModule } from '@lib/fresco';
import { ProfileAssignmentsComponent } from '@app/profile/components/profile-assignments/profile-assignments.component';
import { ProfileGroupsComponent } from '@app/profile/components/profile-groups/profile-groups.component';
import { ProfilePathwaysComponent } from '@app/profile/components/profile-pathways/profile-pathways.component';
import { ProfilePlansComponent } from '@app/profile/components/profile-plans/profile-plans.component';
import { ProfileSavedComponent } from '@app/profile/components/profile-saved/profile-saved.component';
import { ProfileSharedTileComponent } from '@app/profile/components/profile-shared/profile-shared-tile/profile-shared-tile.component';
import { ProfileSharedComponent } from '@app/profile/components/profile-shared/profile-shared.component';
import { ProfileSkillsComponent } from './components/profile-skills/profile-skills.component';
import { ProfileSkillsListOtherRatingsComponent } from '@app/profile/components/profile-skills-list-other-ratings/profile-skills-list-other-ratings.component';
import { ProfileSkillsListPeerRatingsComponent } from '@app/profile/components/profile-skills-list-peer-ratings/profile-skills-list-peer-ratings.component';
import { ProfileSkillsListSelfRatingComponent } from '@app/profile/components/profile-skills-list-self-rating/profile-skills-list-self-rating.component';
import { ProfileSkillsListManagerRatingComponent } from './components/profile-skills-list-manager-rating/profile-skills-list-manager-rating.component';
import { ProfileSkillsListSkillReviewComponent } from './components/profile-skills-list-skill-review/profile-skills-list-skill-review.component';
import { ProfileSkillsListSkillCertificationComponent } from './components/profile-skills-list-skill-certification/profile-skills-list-skill-certification.component';
import { ProfileSkillsListTargetRatingComponent } from './components/profile-skills-list-target-rating/profile-skills-list-target-rating.component';
import { SearchFiltersModule } from '@app/search/components/search-filters/search-filters.module';
import { SharedModule } from '@app/shared/shared.module';
import { TagsModule } from '@app/tags/tags.module';
import { EngagedLearnerModalComponent } from './components/engaged-learner-modal/engaged-learner-modal.component';
import { EngagedCongratulationsModalComponent } from '../shared/components/engaged-congratulations-modal/engaged-congratulations-modal.component';
import { ProfileFilterBarComponent } from './components/profile-filter-bar/profile-filter-bar.component';
import { GroupsSharedModule } from '@app/groups/groups-shared.module';
import { OutcomesModule } from '@app/outcomes/outcomes.module';

import { ProfileSkillsListComponent } from './components/profile-skills-list/profile-skills-list.component';
import { ProfileEmptyState } from './components/profile-empty-state/profile-empty-state.component';

import { SkillTargetsModalComponent } from '@app/skill-standards/components/modals/skill-targets-modal/skill-targets-modal.component';
import { SkillTargetsAdditionalProficiencyLevels } from '@app/skill-standards/components/skill-targets-additional-proficiency-levels/skill-targets-additional-proficiency-levels.component';
import { ProfileSkillStandardsComponent } from './components/profile-skill-standards/profile-skill-standards.component';
import { AddMenu } from './components/profile-overview/components/add-menu/add-menu.component';
import { ProfileCardCarouselComponent } from './components/profile-overview/components/card-carousel/profile-card-carousel.component';
import { ProfileHeadingComponent } from './components/profile-overview/components/header/profile-heading.component';
import { ProfileSectionEmptyStateComponent } from './components/profile-overview/components/section-empty-state/profile-section-empty-state.component';
import { ProfileExperienceComponent } from './components/profile-overview/experiences/profile-experience.component';
import { ProfileLearningComponent } from './components/profile-overview/learning/profile-learning.component';
import { ProfileLearningComponentV2 } from '@app/profile/components/profile-overview/learning-v2/profile-learning.component';
import { ProfileOverviewAchievementsComponent } from './components/profile-overview/achievements/achievements.component';
import { ProfileOverviewAchievementsComponentV2 } from './components/profile-overview/achievements-v2/achievements.component';
import { ProfileSkillSignalPage } from './components/profile-skill-signal-page/profile-skill-signal-page.component';
import { SignalCountChartComponent } from '@app/profile/components/profile-overview/signal-count-chart/signal-count-chart.component';
import { SignalHistoryChartComponent } from '@app/profile/components/profile-overview/signal-history-chart/signal-history-chart.component';
import { SkillSignalActivityChart } from '@app/profile/components/profile-skill-signal-page/components/skill-signal-activity-chart/skill-signal-activity-chart.component';
import { SkillSignalCountPill } from '@app/profile/components/profile-skill-signal-page/components/skill-signal-count-pill/skill-signal-count-pill.component';
import { SkillSignalMoreButton } from '@app/profile/components/profile-skill-signal-page/components/skill-signal-more-button/skill-signal-more-button.component';
import { SkillSignalRatings } from '@app/profile/components/profile-skill-signal-page/components/skill-signal-ratings/skill-signal-ratings.component';
import { SkillSignalShareButton } from '@app/profile/components/profile-skill-signal-page/components/skill-signal-share-button/skill-signal-share-button.component';
import { ProfileCollectionComponentV1 } from './components/profile-collection-v1/profile-collection.component';
import { ProfileCollectionComponent } from './components/profile-collection/profile-collection.component';

import { UserExperienceTile } from './components/user-experience-tile/user-experience-tile.component';
import { UserExperienceDetailsModalComponent } from '@app/profile/components/user-experience-details-modal/user-experience-details-modal.component';
import { ProfileCollectionSearchV1 } from '@app/profile/components/profile-collection-v1/search/profile-collection-search.component';
import { ProfileCollectionSortingComponentV1 } from '@app/profile/components/profile-collection-v1/sorting/profile-collection-sorting.component';
import { ProfileCollectionBulkUpdateV1 } from '@app/profile/components/profile-collection-v1/bulk-update/profile-collection-bulk-update.component';
import { ProfileCollectionBulkUpdateModalV1 } from '@app/profile/components/profile-collection-v1/bulk-update/update-modal/profile-collection-bulk-update-modal.component';
import { ProfileCollectionSearch } from '@app/profile/components/profile-collection/search/profile-collection-search.component';
import { ProfileCollectionSortingComponent } from '@app/profile/components/profile-collection/sorting/profile-collection-sorting.component';
import { ProfileCollectionBulkUpdate } from '@app/profile/components/profile-collection/bulk-update/profile-collection-bulk-update.component';
import { ProfileCollectionBulkUpdateModal } from '@app/profile/components/profile-collection/bulk-update/update-modal/profile-collection-bulk-update-modal.component';

import { TypeFacetFilterV1 } from '@app/profile/components/profile-collection-v1/filters/type-facet-filter/type-facet-filter.component';
import { FacetFiltersV1 } from '@app/profile/components/profile-collection-v1/filters/facet-filters/facet-filters.component';
import { DateFacetFilterV1 } from '@app/profile/components/profile-collection-v1/filters/date-facet-filter/date-facet-filter.component';
import { TypeFacetFilter } from '@app/profile/components/profile-collection/filters/type-facet-filter/type-facet-filter.component';
import { FacetFilters } from '@app/profile/components/profile-collection/filters/facet-filters/facet-filters.component';
import { DateFacetFilter } from '@app/profile/components/profile-collection/filters/date-facet-filter/date-facet-filter.component';

import { RouterModule } from '@angular/router';
import { AchievementDetailComponent } from '@app/profile/components/profile-overview/achievements/achievements-modal/achievement-detail/achievement-detail.component';
import { AchievementModalComponent } from '@app/profile/components/profile-overview/achievements/achievements-modal/achievements-modal.component';
import { UserOutcomeActions } from '@app/profile/components/user-outcome-tile-v2/user-outcome-actions/user-outcome-actions.component';
import { NavigationModule } from '@app/navigation/navigation.module';
import { UserExperienceActionsComponent } from './components/user-experience-tile/user-experience-actions/user-experience-actions.component';
import { UserOutcomeTileV2 } from './components/user-outcome-tile-v2/user-outcome-tile-v2.component';
import { ResourceLauncherModule } from '@app/resource-launcher/resource-launcher.module';

import { ProfileAssignmentsStore } from '@app/profile/components/profile-assignments/profile-assignments-reactive-store/profile-assignments.store';
import { ProfileAssignmentsFacade } from '@app/profile/components/profile-assignments/profile-assignments-reactive-store/profile-assignments.facade';
import { AssignmentsBookmarkService } from '@app/profile/components/profile-assignments/profile-assignments-reactive-store/profile-assignments.bookmark';
import { ProfileOverviewFacade } from '@app/profile/components/profile-overview-v2/profile-overview.facade';
import { AssignmentStatusPipe } from './components/profile-assignments/assignment-status.pipe';
import { ProfileAssignmentsSearchComponent } from './components/profile-assignments/profile-assignments-search/profile-assignments-search.component';
import { ProfileExperiencesFacade } from '@app/profile/components/profile-overview/experiences-v2/profile-experience.facade';
import { ProfileAchievementsFacade } from '@app/profile/components/profile-overview/achievements-v2/achievements.facade';
import { ProfileExperienceComponentV2 } from '@app/profile/components/profile-overview/experiences-v2/profile-experience.component';
import { ProfileLearningFacade } from '@app/profile/components/profile-overview/learning-v2/profile-learning.facade';
import { ProfileSkillSignalsPageFacade } from '@app/profile/components/profile-skill-signals-page-v2/profile-skill-signals-page.facade';
import { ProfileSkillSignalPageV2 } from '@app/profile/components/profile-skill-signals-page-v2/profile-skill-signal-page.component';
import { ProfileSkillSignalServiceV2 } from '@app/profile/components/profile-skill-signals-page-v2/profile-skill-signal-page.service';
import { AddExperienceMenuComponent } from './components/profile-overview/components/add-experience-menu/add-experience-menu.component';

import { ProfileCollectionFacadeV1 } from '@app/profile/components/profile-collection-v1/profile-collection.facade';
import { ProfileCollectionUtilsService } from '@app/profile/components/profile-collection/profile-collection-reactive-store/utils';
import {
  ProfileCollectionFacade,
  ProfileCollectionBookmarkService,
} from '@app/profile/components/profile-collection/profile-collection-reactive-store';

@NgModule({
  declarations: [
    AchievementDetailComponent,
    AchievementModalComponent,
    UserExperienceTile,
    UserExperienceActionsComponent,
    UserExperienceDetailsModalComponent,
    UserOutcomeTileV2,
    ProfileCollectionSearchV1,
    ProfileCollectionSortingComponentV1,
    ProfileCollectionBulkUpdateV1,
    ProfileCollectionBulkUpdateModalV1,
    TypeFacetFilterV1,
    FacetFiltersV1,
    DateFacetFilterV1,
    ProfileCollectionSearch,
    ProfileCollectionSortingComponent,
    ProfileCollectionBulkUpdate,
    ProfileCollectionBulkUpdateModal,
    TypeFacetFilter,
    FacetFilters,
    DateFacetFilter,

    ProfileEmptyState,
    EngagedLearnerModalComponent,
    EngagedCongratulationsModalComponent,
    ProfileAssignmentsComponent,
    ProfileAssignmentsSearchComponent,
    ProfileFilterBarComponent,
    ProfileGroupsComponent,

    ProfileSkillSignalPage,
    ProfileSkillSignalPageV2,
    SignalCountChartComponent,
    SignalHistoryChartComponent,
    SkillSignalActivityChart,
    SkillSignalCountPill,
    SkillSignalRatings,
    SkillSignalShareButton,
    SkillSignalMoreButton,
    ProfileExperienceComponent,
    ProfileOverviewAchievementsComponent,
    ProfileOverviewAchievementsComponentV2,
    ProfileLearningComponent,
    ProfileLearningComponentV2,
    ProfileCardCarouselComponent,
    ProfileSectionEmptyStateComponent,
    ProfileHeadingComponent,
    UserExperienceActionsComponent,
    AddMenu,
    UserOutcomeTileV2,
    ProfileExperienceComponentV2,

    ProfilePathwaysComponent,
    ProfilePlansComponent,
    ProfileSavedComponent,
    ProfileSharedComponent,
    ProfileSharedTileComponent,
    ProfileSkillsListComponent,
    ProfileSkillsListOtherRatingsComponent,
    ProfileSkillsListPeerRatingsComponent,
    ProfileSkillsListSelfRatingComponent,
    ProfileSkillsListManagerRatingComponent,
    ProfileSkillsListSkillReviewComponent,
    ProfileSkillsListSkillCertificationComponent,
    ProfileSkillsListTargetRatingComponent,
    ProfileCollectionComponentV1,
    ProfileCollectionComponent,
    ProfileSkillsComponent,
    SkillTargetsModalComponent,
    SkillTargetsAdditionalProficiencyLevels,
    ProfileSkillStandardsComponent,
    UserOutcomeActions,
    AddExperienceMenuComponent,
  ],
  imports: [
    SearchFiltersModule,
    SharedModule,
    TagsModule,
    GroupsSharedModule,
    OutcomesModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbAccordionModule,
    DfFormlyModule,
    RouterModule,
    NavigationModule,
    ResourceLauncherModule,
  ],
  exports: [
    ProfileEmptyState,
    ProfileAssignmentsComponent,
    ProfileFilterBarComponent,
    ProfileGroupsComponent,
    ProfilePathwaysComponent,
    ProfilePlansComponent,
    ProfileSavedComponent,
    ProfileSharedComponent,
    ProfileSkillsComponent,
    ProfileSkillsListComponent,
    ProfileSkillsListOtherRatingsComponent,
    ProfileSkillsListPeerRatingsComponent,
    ProfileSkillsListSelfRatingComponent,
    ProfileSkillsListManagerRatingComponent,
    ProfileSkillsListSkillReviewComponent,
    ProfileSkillsListSkillCertificationComponent,
    ProfileSkillsListTargetRatingComponent,
    SkillTargetsModalComponent,
    SkillTargetsAdditionalProficiencyLevels,

    ProfileSkillSignalPage,
    ProfileSkillSignalPageV2,
    SignalCountChartComponent,
    SignalHistoryChartComponent,
    SkillSignalActivityChart,
    SkillSignalCountPill,
    SkillSignalRatings,
    SkillSignalShareButton,
    SkillSignalMoreButton,
    ProfileExperienceComponent,
    ProfileExperienceComponentV2,
    ProfileOverviewAchievementsComponent,
    ProfileOverviewAchievementsComponentV2,
    ProfileLearningComponent,
    ProfileLearningComponentV2,
    ProfileCardCarouselComponent,
    ProfileSectionEmptyStateComponent,
    ProfileHeadingComponent,
    UserExperienceActionsComponent,
    AddMenu,
    UserOutcomeTileV2,

    NgbDatepickerModule,
    NgbDropdownModule,
    ProfileCollectionComponentV1,
    ProfileCollectionComponent,
    UserOutcomeTileV2,
    UserExperienceActionsComponent,
  ],
  providers: [
    ProfileOverviewFacade,
    ProfileAssignmentsStore,
    ProfileAssignmentsFacade,
    AssignmentsBookmarkService,
    AssignmentStatusPipe,
    ProfileExperiencesFacade,
    ProfileAchievementsFacade,
    ProfileLearningFacade,
    ProfileSkillSignalsPageFacade,
    ProfileSkillSignalServiceV2,
    ProfileCollectionFacadeV1,
    ProfileCollectionFacade,
    ProfileCollectionUtilsService,
    ProfileCollectionBookmarkService,
  ],
})
export class ProfileSharedModule {}
